import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { SnackbarService } from 'app/core';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css']
})
export class DeleteModalComponent {

  constructor(
    public dialogRef: MatDialogRef<DeleteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: SnackbarService) {
     }

  onNoClick(): void {
    this.dialogRef.close({deleted: false});
  }

  confirmDelete(): void {
    this.dialogRef.close({deleted: true});
  }
}
